import React, { Component } from 'react';
import { validateUniqueCharacters } from '../../utils/functions';
import ChangePasswordForm from './ChangePasswordForm';
import { SubmissionError } from 'redux-form/immutable';
import NotificationWindow from '../NotificationWindow';
import {
  ERROR_NO_OLD_PASSWORD,
  ERROR_PASSWORD_TOO_LONG,
  ERROR_PASSWORD_TOO_SHORT,
  ERROR_PASSWORD_MUST_CONTAIN_UNIQUE,
  ERROR_PASSWORDS_DO_NOT_MATCH,
  ERROR_SERVER_ERROR,
  SUCCESS_MESSAGE
} from 'utils/constants';

class ChangePassword extends Component {
  constructor(props) {
    super(props);

    this.state = {
      submitErrors: [],
      successful: false
    };

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(values) {
    const obj = values.toJS();
    this.setState({ submitErrors: [] });

    if (!obj.oldPassword) {
      throw new SubmissionError({
        _error: ERROR_NO_OLD_PASSWORD
      });
    }

    if (!obj.password || obj.password.length < 8) {
      throw new SubmissionError({
        _error: ERROR_PASSWORD_TOO_SHORT
      });
    }

    if (obj.password && obj.password.length > 64) {
      throw new SubmissionError({
        _error: ERROR_PASSWORD_TOO_LONG
      });
    }

    if (!validateUniqueCharacters(obj.password, 3)) {
      throw new SubmissionError({
        _error: ERROR_PASSWORD_MUST_CONTAIN_UNIQUE
      });
    }

    if (!obj.confirmPassword || obj.password !== obj.confirmPassword) {
      throw new SubmissionError({
        _error: ERROR_PASSWORDS_DO_NOT_MATCH
      });
    }

    return this.props
      .changePassword(obj.oldPassword, obj.password)
      .then(res => {
        if (
          res &&
          res.data &&
          res.data.changePassword &&
          typeof res.data.changePassword.success !== 'undefined' &&
          res.data.changePassword.message
        ) {
          if (res.data.changePassword.success) {
            this.setState({
              successful: true
            });
          } else {
            this.setState({
              submitErrors: [res.data.changePassword.message]
            });
          }
        } else {
          this.setState({ submitError: [ERROR_SERVER_ERROR] });
        }
        return res;
      })
      .catch(() => {
        this.setState({ submitError: [ERROR_SERVER_ERROR] });
      });
  }

  render() {
    if (this.state.successful) {
      return <NotificationWindow message={SUCCESS_MESSAGE} />;
    } else {
      return (
        <ChangePasswordForm
          resetPassword={false}
          onSubmit={this.handleSubmit}
          submitErrors={this.state.submitErrors}
          successful={this.state.successful}
        />
      );
    }
  }
}

export default ChangePassword;



// WEBPACK FOOTER //
// ./src/components/ChangePassword/index.js